import { render, staticRenderFns } from "./viewMenuAuthority.vue?vue&type=template&id=3ca9b998&scoped=true&"
import script from "./viewMenuAuthority.vue?vue&type=script&lang=js&"
export * from "./viewMenuAuthority.vue?vue&type=script&lang=js&"
import style0 from "./viewMenuAuthority.vue?vue&type=style&index=0&id=3ca9b998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca9b998",
  null
  
)

export default component.exports